/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SizeVariant } from './SizeVariant';
import type { Thumbnail } from './Thumbnail';

export type Option = {
    id: string;
    isVisible: boolean;
    sizeVariants?: Array<SizeVariant>;
    title: string;
    description: string;
    thumbnail: Thumbnail;
    orderCode: string;
    boxSize?: string;
    pricePerUnit: number;
    priceType: Option.priceType;
    ghModelJson: string;
    optionTypeId: string;
    optionFolderId: string;
    optionGroupId?: string;
    parentOptionIds: Array<string>;
    conflictOptionIds: Array<string>;
    components?: Array<{ orderCode: string; pricePerUnit: number; priceType: string; upgradedPricePerUnit?: number }>;
}

export namespace Option {

    export enum priceType {
        FIXED = 'FIXED',
        SQ_FT_ = 'SQ. FT.',
        LINEAR_FT_ = 'LINEAR FT.',
        WALL_AREA = 'WALL AREA',
    }


}
